import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const NoComparisonsIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        width="180"
        height="181"
        viewBox="0 0 180 181"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <ellipse cx="89.6849" cy="172.111" rx="48.0912" ry="8.88889" fill="black" />
        <path
            d="M135.837 174.618C137.099 173.823 137.776 172.982 137.776 172.111C137.776 167.202 116.245 163.222 89.6849 163.222C63.1249 163.222 41.5938 167.202 41.5938 172.111C41.5938 172.982 42.2709 173.823 43.5332 174.618C49.3887 170.93 67.8351 168.236 89.6849 168.236C111.535 168.236 129.981 170.93 135.837 174.618Z"
            fill="#666666"
        />
        <path d="M96.4061 110.63H82.332V181H96.4061V110.63Z" fill="url(#paint0_linear_5551_9272)" />
        <path d="M96.4061 110.63H82.332V129.889H96.4061V110.63Z" fill="#BDD6E0" />
        <circle cx="90" cy="62" r="61.5" fill="#2D67DA" stroke="#C9C9C9" />
        <circle cx="90" cy="62" r="56" fill="#2D67DA" stroke="white" strokeWidth="10" />
        <path
            d="M103.056 77.3125V46.6875C103.056 45.4844 104.056 44.5 105.278 44.5C106.5 44.5 107.5 45.4844 107.5 46.6875V77.3125C107.5 78.5156 106.5 79.5 105.278 79.5C104.056 79.5 103.056 78.5156 103.056 77.3125Z"
            fill="white"
        />
        <path
            d="M92.8704 77.3125V59.8125C92.8704 58.6094 93.8704 57.625 95.0926 57.625C96.3148 57.625 97.3148 58.6094 97.3148 59.8125V77.3125C97.3148 78.5156 96.3148 79.5 95.0926 79.5C93.8704 79.5 92.8704 78.5156 92.8704 77.3125Z"
            fill="white"
        />
        <path
            d="M82.6852 52.5208V77.3125C82.6852 78.5156 83.6852 79.5 84.9074 79.5C86.1296 79.5 87.1296 78.5156 87.1296 77.3125V52.5208C87.1296 51.3177 86.1296 50.3333 84.9074 50.3333C83.6852 50.3333 82.6852 51.3177 82.6852 52.5208Z"
            fill="white"
        />
        <path
            d="M72.5 77.3125L72.5 62C72.5 60.7969 73.5 59.8125 74.7222 59.8125C75.9444 59.8125 76.9444 60.7969 76.9444 62V77.3125C76.9444 78.5156 75.9444 79.5 74.7222 79.5C73.5 79.5 72.5 78.5156 72.5 77.3125Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5551_9272"
                x1="82.332"
                y1="146.923"
                x2="96.4061"
                y2="146.923"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E6EBF4" />
                <stop offset="0.381479" stopColor="white" />
                <stop offset="0.666667" stopColor="white" />
                <stop offset="1" stopColor="#E6EBF4" />
            </linearGradient>
        </defs>
    </svg>
);